export const reducer = (state = {}, action) => state;
export const selectRoot = state => state.schedule;
export const select = (localState, id) => state[id];
export const get = (state, id) => select(selectRoot(state), id);
